import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getCollectionByShareToken } from '@/store/reducers/collection/actions';
import { selectCollection, selectIsLoading } from '@/store/reducers/collection/collectionSlice';
import { ModalType } from '@/types/modals';
import { useModal } from '@/hooks/useModal';
import CollectionView from '@/components/CollectionView';
import PageLoader from '@/components/PageLoader';
import analytics from '@/utils/analytics/analyticsInstance';

export default function ShareCollectionPage() {
  const { token } = useParams<{ token: string }>();
  const { openModal } = useModal(ModalType.OpenAppModal);
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);
  const collection = useAppSelector(selectCollection);

  useEffect(() => {
    if (!isLoading) openModal();
  }, [openModal, isLoading]);

  useEffect(() => {
    if (token) {
      dispatch(getCollectionByShareToken(token));

      analytics.track('webContentLinkOpened', {
        content_source: window.location.href,
      });
    }
  }, [dispatch, token]);

  if (!token) {
    return <Navigate to="/*" replace />;
  }

  if (isLoading) {
    return <PageLoader text="Loading..." variant="dark" />;
  }

  if (!collection) {
    return <Navigate to="/*" replace />;
  }

  return <CollectionView {...collection} />;
}
